/**
 * Copyright © 2025 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
